'use client';

import { useRouter } from 'next/navigation';
import { memo, useEffect } from 'react';
import cookie from 'react-cookies';

import { EGlobalCookieKey } from '@/types/cookie';
import { DEFAULT_ROUTER, ROUTER_PATH } from '@/utils/router';

function Redirect404(): null {
  const router = useRouter();

  useEffect(() => {
    const token = cookie.load(EGlobalCookieKey.token);

    router.replace(token ? DEFAULT_ROUTER : ROUTER_PATH.login);
  }, [router]);

  return null;
}

export default memo(Redirect404);
